import { useQuery } from '@tanstack/react-query'
import { getData } from '../../../apis/api.helpers'
import apiUrl from '../../../apis/api.url'
import { QueryParams } from '../../../common/types'

export const buildUrlWithParams = (
  baseUrl: string,
  params: Record<string, any>
) => {
  const query = new URLSearchParams(params).toString()
  return `${baseUrl}?${query}`
}

const fetchIncubationist = async (input: QueryParams) => {
  const url = buildUrlWithParams(apiUrl.INCUBATION_LISTING, {
    ...input,
  })
  const response = await getData(url)
  return response
}

export const useIncubationListing = (input: QueryParams) => {
  return useQuery(
    ['admin_user_list', input],
    () => fetchIncubationist(input),
    {}
  )
}

const incubationDetails = async (id: string) => {
  const url = `${apiUrl.INCUBATION_DETAIL}/${id}`
  const response = await getData(url)
  return response
}
export const useIncubationDetails = (id: string) => {
  return useQuery(['worker_task', id], () => incubationDetails(id), {
    refetchOnWindowFocus: false,
  })
}
